import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Empty: FC<SvgIconProps> = (props) => <SvgIcon width="24" height="24" {...props} />
